"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TicketCloseReason = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _OrderCard = _interopRequireDefault(require("../../Orders/OrderCard"));
var _Modal = _interopRequireDefault(require("../../../Modal"));
var _Radio = _interopRequireDefault(require("../../../Radio"));
var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));
var _Input = _interopRequireDefault(require("../../../Input"));
var _RadioGroup = _interopRequireDefault(require("../../../RadioGroup"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _OnClickOutside = _interopRequireDefault(require("../../../OnClickOutside"));
var _constants = require("../../Orders/OrderStatus/constants");
var _iconsReact = require("../../../../icons-react");
var _excluded = ["id", "status"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var STATUS = {
  SUCCESS: 'success',
  FAILURE: 'failure'
};
var TicketCloseReason = exports.TicketCloseReason = function TicketCloseReason(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    prefilledReasonId = props.reasonId,
    prefilledOrderIds = props.orderIds,
    isClosable = props.isClosable,
    reasonOptions = props.reasonOptions,
    orderOptions = props.orderOptions,
    suggestedOrders = props.suggestedOrders,
    _props$onOrderSearch = props.onOrderSearch,
    onOrderSearch = _props$onOrderSearch === void 0 ? Function.prototype : _props$onOrderSearch,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? Function.prototype : _props$onClose,
    _props$onSubmit = props.onSubmit,
    onSubmit = _props$onSubmit === void 0 ? Function.prototype : _props$onSubmit,
    _props$onReasonChange = props.onReasonChange,
    onReasonChange = _props$onReasonChange === void 0 ? Function.prototype : _props$onReasonChange,
    _props$onOrderChange = props.onOrderChange,
    onOrderChange = _props$onOrderChange === void 0 ? Function.prototype : _props$onOrderChange;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isForceHidden = _useState2[0],
    setForceHidden = _useState2[1];
  var _useState3 = (0, _react.useState)(prefilledReasonId || null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    reasonId = _useState4[0],
    setReason = _useState4[1];
  var _useState5 = (0, _react.useState)(prefilledOrderIds || []),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    orderIds = _useState6[0],
    setOrderIds = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    status = _useState8[0],
    setCloseStatus = _useState8[1];
  var activeReasonOptions = (0, _react.useMemo)(function () {
    return reasonOptions === null || reasonOptions === void 0 ? void 0 : reasonOptions.filter(function (_ref) {
      var isActive = _ref.isActive;
      return isActive;
    });
  }, [reasonOptions, reasonOptions === null || reasonOptions === void 0 ? void 0 : reasonOptions.length]);
  var handleCloseStatus = (0, _react.useCallback)(function (_ref2) {
    var target = _ref2.target;
    setCloseStatus(target.value);
  }, [setReason, setOrderIds, setCloseStatus]);
  var handleCloseModal = (0, _react.useCallback)(function () {
    setForceHidden(true);
    onClose();
  }, [onClose, setForceHidden]);
  var handleReasonChange = (0, _react.useCallback)(function (_ref3) {
    var target = _ref3.target;
    setReason(target.value);
  }, [onReasonChange]);
  var handleOrderChange = (0, _react.useCallback)(function (_ref4) {
    var target = _ref4.target;
    var value = target.value;
    var updatedOrderIds = orderIds.includes(value) ? orderIds.filter(function (id) {
      return id !== value;
    }) : [].concat((0, _toConsumableArray2["default"])(orderIds), [value]);
    setOrderIds((0, _uniq2["default"])(updatedOrderIds));
  }, [orderIds, onOrderChange]);
  var _useState9 = (0, _react.useState)(''),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    ordersInput = _useState10[0],
    setOrdersInput = _useState10[1];
  var showOwnOrders = ordersInput.length > 2;
  var handleOrdersInput = (0, _react.useCallback)(function (_ref5) {
    var target = _ref5.target;
    var query = target.value;
    setOrdersInput(query);
    if (showOwnOrders) {
      onOrderSearch({
        query: query
      });
    }
  }, [showOwnOrders, onOrderSearch]);
  var handleSubmit = (0, _react.useCallback)(function () {
    if (status === STATUS.SUCCESS) {
      onSubmit({
        orderIds: orderIds
      });
    }
    if (status === STATUS.FAILURE) {
      onSubmit({
        closeReasonId: reasonId
      });
    }
  }, [status, orderIds, reasonId, onSubmit]);
  var orders = showOwnOrders ? suggestedOrders : orderOptions;
  if (!isClosable) {
    return !isForceHidden && /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      shadow: false
    }, /*#__PURE__*/_react["default"].createElement(_OnClickOutside["default"], {
      onClickOutside: handleCloseModal
    }, /*#__PURE__*/_react["default"].createElement(StyledTicketCloseReason, {
      className: className
    }, /*#__PURE__*/_react["default"].createElement(StyledHead, null, /*#__PURE__*/_react["default"].createElement(StyledTitle, null, "\u0422\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      functional: true,
      onClick: handleCloseModal
    }, /*#__PURE__*/_react["default"].createElement(_iconsReact.FieldClose, {
      width: 14
    }))), /*#__PURE__*/_react["default"].createElement(StyledBottom, null, /*#__PURE__*/_react["default"].createElement(StyledSubmitButton, {
      onClick: handleCloseModal
    }, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C")))), /*#__PURE__*/_react["default"].createElement(StyledShadow, null));
  }
  return !isForceHidden && /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    shadow: false
  }, /*#__PURE__*/_react["default"].createElement(_OnClickOutside["default"], {
    onClickOutside: handleCloseModal
  }, /*#__PURE__*/_react["default"].createElement(StyledTicketCloseReason, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledHead, null, /*#__PURE__*/_react["default"].createElement(StyledTitle, null, reasonId ? 'Закрытие тикета' : 'Причина закрытия'), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    functional: true,
    onClick: handleCloseModal
  }, /*#__PURE__*/_react["default"].createElement(_iconsReact.FieldClose, {
    width: 14
  }))), !status && /*#__PURE__*/_react["default"].createElement(StyledBottom, null, /*#__PURE__*/_react["default"].createElement(StyledFailureButton, {
    value: STATUS.FAILURE,
    onClick: handleCloseStatus
  }, "\u041A\u043B\u0438\u0435\u043D\u0442 \u043E\u0442\u043A\u0430\u0437\u0430\u043B\u0441\u044F"), /*#__PURE__*/_react["default"].createElement(StyledSuccessButton, {
    value: STATUS.SUCCESS,
    onClick: handleCloseStatus
  }, "\u041A\u043B\u0438\u0435\u043D\u0442 \u0437\u0430\u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043B \u0437\u0430\u043A\u0430\u0437")), status === STATUS.SUCCESS && /*#__PURE__*/_react["default"].createElement(StyledOrders, null, /*#__PURE__*/_react["default"].createElement(StyledOrdersInputContainer, null, /*#__PURE__*/_react["default"].createElement(StyledOrdersInput, {
    placeholder: "\u041F\u043E\u0438\u0441\u043A \u0437\u0430\u043A\u0430\u0437\u043E\u0432",
    onChange: handleOrdersInput
  })), orders && orders.map(function (_ref6) {
    var id = _ref6.id,
      orderStatus = _ref6.status,
      order = (0, _objectWithoutProperties2["default"])(_ref6, _excluded);
    return orderStatus !== _constants.ORDER_STATUSES.CANCELED && /*#__PURE__*/_react["default"].createElement(StyledOrderRadio, {
      key: id,
      value: id,
      onChange: handleOrderChange,
      checked: orderIds.includes(id)
    }, /*#__PURE__*/_react["default"].createElement(_OrderCard["default"], (0, _extends2["default"])({
      id: id,
      status: orderStatus
    }, order, {
      tickets: null
    })));
  })), status === STATUS.FAILURE && /*#__PURE__*/_react["default"].createElement(StyledReasons, {
    name: "reasons",
    onChange: handleReasonChange,
    selected: reasonId
  }, activeReasonOptions.map(function (_ref7) {
    var value = _ref7.value,
      label = _ref7.label;
    return /*#__PURE__*/_react["default"].createElement(StyledReasonRadio, {
      key: value,
      value: String(value),
      label: label
    }, label);
  })), status && /*#__PURE__*/_react["default"].createElement(StyledBottom, null, /*#__PURE__*/_react["default"].createElement(StyledBackButton, {
    value: null,
    onClick: handleCloseStatus
  }, "\u041D\u0430\u0437\u0430\u0434"), /*#__PURE__*/_react["default"].createElement(StyledSubmitButton, {
    disabled: !(reasonId || !(0, _isEmpty2["default"])(orderIds)),
    onClick: handleSubmit
  }, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C")))), /*#__PURE__*/_react["default"].createElement(StyledShadow, null));
};
var StyledHead = _styledComponents["default"].div.withConfig({
  displayName: "TicketCloseReason__StyledHead",
  componentId: "sc-o3kjx3-0"
})(["display:flex;align-items:baseline;justify-content:space-between;padding:16px;"]);
var StyledBottom = _styledComponents["default"].div.withConfig({
  displayName: "TicketCloseReason__StyledBottom",
  componentId: "sc-o3kjx3-1"
})(["display:flex;padding:0 16px 16px;"]);
var StyledFailureButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TicketCloseReason__StyledFailureButton",
  componentId: "sc-o3kjx3-2"
})(["color:#d0021b;border-color:#d0021b;width:fit-content;margin-right:7px;background:white;:hover{border-color:#d0021b;color:#d0021b;}"]);
var StyledSuccessButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TicketCloseReason__StyledSuccessButton",
  componentId: "sc-o3kjx3-3"
})(["color:white;background:#28bd61;border-color:transparent;width:fit-content;:hover{border-color:transparent;color:white;}"]);
var StyledTitle = _styledComponents["default"].h4.withConfig({
  displayName: "TicketCloseReason__StyledTitle",
  componentId: "sc-o3kjx3-4"
})(["font-size:18px;font-weight:bold;margin-right:10px;"]);
var StyledBackButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TicketCloseReason__StyledBackButton",
  componentId: "sc-o3kjx3-5"
})(["border-color:#007aff;background:white;margin-right:7px;flex:1;:hover{background:white;}"]);
var StyledSubmitButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TicketCloseReason__StyledSubmitButton",
  componentId: "sc-o3kjx3-6"
})(["border-color:transparent;background:#007aff;color:white;flex:1;:hover{color:white;background:#007aff;}", ""], function (props) {
  return props.disabled && "\n    border-color: transparent;\n    color: #919499;\n    background: #E6E9EE;\n\n    :hover {\n      color: #919499;\n      background: #E6E9EE;\n    }\n  ";
});
var StyledOrders = _styledComponents["default"].div.withConfig({
  displayName: "TicketCloseReason__StyledOrders",
  componentId: "sc-o3kjx3-7"
})(["width:400px;margin-bottom:16px;max-height:calc(100vh - 400px);overflow:auto;"]);
var StyledOrderRadio = (0, _styledComponents["default"])(_Checkbox["default"]).withConfig({
  displayName: "TicketCloseReason__StyledOrderRadio",
  componentId: "sc-o3kjx3-8"
})(["padding:5px 16px;align-items:flex-start;input{margin-right:10px;}:hover{background:#e6f2ff;}"]);
var StyledReasonRadio = (0, _styledComponents["default"])(_Radio["default"]).withConfig({
  displayName: "TicketCloseReason__StyledReasonRadio",
  componentId: "sc-o3kjx3-9"
})(["padding:0 10px;min-height:40px;border:1px solid #e6e9ee;border-radius:4px;margin-bottom:8px;margin-right:8px;width:calc(50% - 4px);:hover{background:#e6f2ff;}input{display:none;}", ""], function (props) {
  return props.checked && "\n    color: white;\n    background: #007AFF;\n    border: transparent;\n\n    :hover {\n      color: white;\n      background: #007AFF;\n    }\n  ";
});
var StyledReasons = (0, _styledComponents["default"])(_RadioGroup["default"]).withConfig({
  displayName: "TicketCloseReason__StyledReasons",
  componentId: "sc-o3kjx3-10"
})(["width:500px;padding:0 16px;margin-bottom:8px;flex-flow:row wrap;display:flex;max-height:calc(100vh - 400px);overflow:auto;", "{&:nth-child(2n){margin-right:0;}}"], StyledReasonRadio);
var StyledTicketCloseReason = _styledComponents["default"].div.withConfig({
  displayName: "TicketCloseReason__StyledTicketCloseReason",
  componentId: "sc-o3kjx3-11"
})(["position:relative;background:white;width:fit-content !important;border-radius:4px;margin-top:150px !important;margin-left:auto !important;margin-right:auto !important;left:0;right:0;z-index:99;"]);
var StyledShadow = _styledComponents["default"].div.withConfig({
  displayName: "TicketCloseReason__StyledShadow",
  componentId: "sc-o3kjx3-12"
})(["top:0;left:0;right:0;bottom:0;z-index:-1;position:fixed;touch-action:none;background-color:rgba(0,0,0,0.2);-webkit-tap-highlight-color:transparent;"]);
var StyledOrdersInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "TicketCloseReason__StyledOrdersInput",
  componentId: "sc-o3kjx3-13"
})(["width:100%;"]);
var StyledOrdersInputContainer = _styledComponents["default"].div.withConfig({
  displayName: "TicketCloseReason__StyledOrdersInputContainer",
  componentId: "sc-o3kjx3-14"
})(["padding:0 15px 15px;"]);
var _default = exports["default"] = TicketCloseReason;